module.exports = __webpack_public_path__ + "img/13-small.9267629f.png";